export const API_BASE_URL =
  process.env.NODE_ENV === 'development' ? 'http://localhost:3001/api' : '/api';

export const DEFAULT_HEADERS = {
  'Content-Type': 'application/json',
};
